// src/App.jsx
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Navbar from "./components/homepage/Navbar";
import Home from "./pages/Home";
import KalonMethod from "./pages/KalonMethod";
import MyJourney from "./pages/MyJourney";
import Coaching from "./pages/Coaching";

import Contact from "./pages/Contact";
import ContactConfirmation from "./pages/confirmation_pages/ContactConfirmation";


import Blogs from "./pages/Blogs";
import Colorado14ersBlog from "./pages/blog_posts/colorado_14ers_blog";
import ModelPhysiqueWithoutBulking from "./pages/blog_posts/model_physique_without_bulking";
import NutritionForProfessionals from "./pages/blog_posts/nutrition_for_professionals";
import StrengthForLongevity from "./pages/blog_posts/strength_for_longetivity";

import Programs from "./pages/Programs";
import EnduranceProgram from "./components/programs/EnduranceProgram";
import EnduranceBeginnerPlans from "./components/programs/EndurancePlans/EnduranceBeginnerPlans";
import EnduranceAdvancePlans from "./components/programs/EndurancePlans/EnduranceAdvancePlans";

import StrengthProgram from "./components/programs/StrengthProgram";
import StrengthBeginnerPlans from "./components/programs/StrengthPlans/StrengthBeginnerPlans";
import StrengthAdvancePlans from "./components/programs/StrengthPlans/StrengthAdvancePlans";

import SportsProgram from "./components/programs/SportsProgram";
import SportsBeginnerProgram from "./components/programs/SportsPlans/SportsBeginnerPlans";
import SportsAdvanceProgram from "./components/programs/SportsPlans/SportsAdvancePlans";

import ApplyNow from "./pages/ApplyNow";
import ApplyConfirmation from "./pages/confirmation_pages/ApplyConfirmation";


import "@fortawesome/fontawesome-free/css/all.min.css";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Always scroll to the top on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [location]);

  useEffect(() => {
    // Scroll to top on browser back/forward
    const handlePopState = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return null;
}

function App() {
  return (
    <div className="relative w-full min-h-screen overflow-x-hidden">
      {/* Global Fixed Background */}
      <div className="fixed inset-0 z-[-1] flex justify-center items-start">
        <img
          src={require("./assets/global_background.jpg")}
          alt="Background"
          className="w-screen h-screen object-cover"
        />
      </div>

      <Router>
        <ScrollToTop />

        <Navbar />

        <div className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/kalon-method" element={<KalonMethod />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/my-journey" element={<MyJourney />} />

            <Route path="/blog" element={<Blogs />} />
            <Route
              path="/blog/colorado-14ers"
              element={<Colorado14ersBlog />}
            />
            <Route
              path="/blog/model-physique-without-bulking"
              element={<ModelPhysiqueWithoutBulking />}
            />
            <Route
              path="/blog/nutrition-for-professionals"
              element={<NutritionForProfessionals />}
            />
            <Route
              path="/blog/strength-for-longevity"
              element={<StrengthForLongevity />}
            />

            <Route path="/coaching" element={<Coaching />} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/contact-confirmation" element={<ContactConfirmation />} />


            <Route path="/programs/endurance" element={<EnduranceProgram />} />
            <Route
              path="/endurance/beginner"
              element={<EnduranceBeginnerPlans />}
            />
            <Route
              path="/endurance/advanced"
              element={<EnduranceAdvancePlans />}
            />

            <Route path="/programs/strength" element={<StrengthProgram />} />
            <Route
              path="/strength/beginner"
              element={<StrengthBeginnerPlans />}
            />
            <Route
              path="/strength/advanced"
              element={<StrengthAdvancePlans />}
            />

            <Route path="/programs/sports" element={<SportsProgram />} />
            <Route
              path="/sports/beginner"
              element={<SportsBeginnerProgram />}
            />
            <Route path="/sports/advance" element={<SportsAdvanceProgram />} />

            <Route path="/apply-now" element={<ApplyNow />} />
            <Route path="/apply-confirmation" element={<ApplyConfirmation />} />

          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
